module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    directives: [{
      name: "drag-modal",
      rawName: "v-drag-modal"
    }],
    attrs: {
      "title": "新增上课要求",
      "width": "700",
      "mask-closable": false
    },
    on: {
      "on-cancel": _vm.handleCancel
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "60vh",
      "overflow-y": "auto",
      "padding-right": "5px"
    }
  }, [_c('Form', {
    ref: "classRequirementForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.formData.uid) + " - " + _vm._s(_vm.formData.studentName))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11,
      "offset": "2"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.formData.tchId) + " - " + _vm._s(_vm.formData.tchName))])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("(外管审核后显示给老师)")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h5', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0 10px 8px 0"
    }
  }, [_vm._v("一般需求:")]), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.formData.classRequirementTags),
      callback: function($$v) {
        _vm.$set(_vm.formData, "classRequirementTags", $$v)
      },
      expression: "formData.classRequirementTags"
    }
  }, [_c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "活跃一些"
    }
  }, [_c('span', [_vm._v("活跃一些")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "多微笑，不要太严肃"
    }
  }, [_c('span', [_vm._v("多微笑，不要太严肃")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "纠音"
    }
  }, [_c('span', [_vm._v("纠音")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "纠正错误表达"
    }
  }, [_c('span', [_vm._v("纠正错误表达")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "引导多开口"
    }
  }, [_c('span', [_vm._v("引导多开口")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "多些互动"
    }
  }, [_c('span', [_vm._v("多些互动")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "引导整句输出"
    }
  }, [_c('span', [_vm._v("引导整句输出")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "多鼓励孩子"
    }
  }, [_c('span', [_vm._v("多鼓励孩子")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "多给些奖励"
    }
  }, [_c('span', [_vm._v("多给些奖励")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h5', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0 10px 8px 0"
    }
  }, [_vm._v("低级别上课需求:")]), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.formData.classRequirementTags),
      callback: function($$v) {
        _vm.$set(_vm.formData, "classRequirementTags", $$v)
      },
      expression: "formData.classRequirementTags"
    }
  }, [_c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "语速慢一点"
    }
  }, [_c('span', [_vm._v("语速慢一点")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "多些 TPR"
    }
  }, [_c('span', [_vm._v("多些 TPR")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "多些道具"
    }
  }, [_c('span', [_vm._v("多些道具")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "课前互动简单一些最多3个问题"
    }
  }, [_c('span', [_vm._v("课前互动简单一些最多3个问题")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "学生零基础，不要拓展"
    }
  }, [_c('span', [_vm._v("学生零基础，不要拓展")])]), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "减少拓展"
    }
  }, [_c('span', [_vm._v("减少拓展")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h5', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0 10px 8px 0"
    }
  }, [_vm._v("高级别上课需求:")]), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.formData.classRequirementTags),
      callback: function($$v) {
        _vm.$set(_vm.formData, "classRequirementTags", $$v)
      },
      expression: "formData.classRequirementTags"
    }
  }, [_c('Checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "内容拓展"
    }
  }, [_c('span', [_vm._v("内容拓展")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "classRequirement",
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 10
      },
      "placeholder": "可额外输入其他上课要求，支持中文哦"
    },
    model: {
      value: (_vm.formData.classRequirement),
      callback: function($$v) {
        _vm.$set(_vm.formData, "classRequirement", $$v)
      },
      expression: "formData.classRequirement"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    staticStyle: {
      "width": "40%",
      "margin": "0 10px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveClassRequirement
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "width": "40%",
      "margin": "0 10px"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6471a15a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/modal/AddClassRequirementModal.vue
// module id = 1859
// module chunks = 8